// extracted by mini-css-extract-plugin
export var container = "_8m-0";
export var icon = "_8m-1";
export var text = "_8m-2";